"use client";

import { useSelectedLayoutSegments } from "next/navigation";
import { switchPath } from "@/i18n/routes";
import { useLocale } from "./locale-context";

/**
 * Geçerli sayfanın tarayıcıdaki adresi (sorgusuz), kök düzenin altındaki iç yol parçalarından hesaplanır.
 * usePathname yerine kullanılır: proxy yeniden yazmasında (/hakkimizda → /tr/hakkimizda) sunucu ve tarayıcıdaki
 * değer aynı kalır, hidrasyon uyumsuzluğu olmaz (bkz. Next.js usePathname belgesi, "rewrites").
 */
export function useCurrentPath(): string {
  return switchPath(useSelectedLayoutSegments(), useLocale());
}
